module.exports = __webpack_public_path__ + "img/banner.92b50504.png";